module.exports = __webpack_public_path__ + "static/media/loading.92210268.gif";